import { Injectable } from '@angular/core';
import {
  BaseControl,
  Custom,
  SubForma,
  Textbox,
} from '@app/shared';
import { Validators } from '@angular/forms';


@Injectable()
export class DefaultValuesFormService {

  constructor() { }

  /**
   * Rewtorna el formulario de agregar o modificar valor por defecto
   *
   * @param {*} templeteForm
   * @param {*} [defaultValue]
   * @returns {BaseControl<any>[]}
   * @memberof DefaultValuesFormService
   */
  getFormDefaultValues(templeteForm: any, defaultValue?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboCampo',
        template: templeteForm,
        label: 'Campo:',
        placeholder: 'Seleccione el campo a asignar el valor por defecto',
        order: 1,
        value: defaultValue ? defaultValue.campo : null,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'txtValorPorDefecto',
        type: 'text',
        label: 'Valor por defecto',
        order: 2,
        value: defaultValue ? defaultValue.valor : null,
        validations: {
          validators: [Validators.required]
        }
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/default-values/shared/default-values.form.service.ts